import React, { useState } from "react";
import { Paper, TextareaAutosize } from "@mui/material";
import Draggable from "react-draggable";
import Buttons from "./ButtonControlPanelNoXY";

const CardStack = ({ textArray, onTextChange }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleCardHover = (index) => {
    setHoveredCard(index);
  };

  return (
    <div>
      <div
        style={{
          display: "grid",
          placeItems: "center",
          minHeight: "100vh",
          overflow: "auto",
          fontFamily: "Inter, sans-serif",
          background: "#242424"
        }}
      >
        <div
          className="card_stack"
          style={{
            "--card-shown-x": "10rem",
            "--card-shown-y": "6rem",
            "--card-size-x": "16rem",
            "--card-size-y": "10rem",
            "--card-padding": "1.5rem",
            display: "flex",
            flexDirection: "column",
            paddingRight:
              "calc(var(--card-size-x) - var(--card-shown-x) + 2 * var(--card-padding))",
            paddingBottom:
              "calc(var(--card-size-y) - var(--card-shown-y) + 2 * var(--card-padding))"
          }}
        >
          {textArray.map((text, index) => (
            <Draggable key={index}>
              <div
                className="card_container"
                style={{
                  position: "relative",
                  marginLeft: `calc((${index} - 1) * var(--card-shown-x))`,
                  width: "var(--card-shown-x)",
                  height: "var(--card-shown-y)",
                  zIndex: hoveredCard === index ? "999" : "auto"
                }}
                onMouseEnter={() => handleCardHover(index)}
              >
                <Paper
                  className="card"
                  elevation={3}
                  style={{
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    minWidth: "var(--card-size-x)",
                    minHeight: "var(--card-size-y)",
                    padding: "var(--card-padding)",
                    borderRadius: "1rem",
                    background: "#2C2C2C",
                    color: "white",
                    boxShadow: "0 0 1.5rem -0.25rem rgba(0, 0, 0, 0.75)"
                  }}
                >
                  <h2
                    style={{
                      margin: "0",
                      fontSize: "1.75rem",
                      fontWeight: "500",
                      color: "white",
                      marginBottom: "0.5rem"
                    }}
                  >
                    {text.keyword}
                  </h2>
                  <TextareaAutosize
                    defaultValue={text.paragraph}
                    onChange={(e) => onTextChange(index, e.target.value)}
                    style={{
                      resize: "none",
                      background: "transparent",
                      border: "none",
                      color: "inherit",
                      fontSize: "1.25rem",
                      fontFamily: "inherit",
                      lineHeight: "1.5",
                      color: "white"
                    }}
                  />
                </Paper>
                <div
                  className="ghost"
                  style={{
                    zIndex: "1",
                    opacity: "0",
                    transition: "0.25s ease"
                  }}
                ></div>
              </div>
            </Draggable>
          ))}
        </div>
      </div>
      <Buttons texts={textArray} />
    </div>
  );
};
export default CardStack;
